/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_TICKET_QUERY,
  ADD_TICKET_QUERY,
  UPDATE_TICKET_QUERY,
  DELETE_TICKET_QUERY,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadTicketQuery,
  loadTicketQueryError,
  loadTicketQuerySuccess,
  addTicketQueryError,
  addTicketQuerySuccess,
  addTicketQuery,
  updateTicketQuerySuccess,
  updateTicketQueryError,
  updateTicketQuery,
  deleteTicketQuerySuccess,
  deleteTicketQueryError,
  deleteTicketQuery,
} from "./actions"

import {
  loadTicketQueryDetails,
  loadRecordsMetaData,
  addTicketQueryDetails,
  updateTicketQueryDetails,
  deleteTicketQueryDetails,
} from "./remotes"

function* loadTicketQueryDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_TICKET_QUERY),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadTicketQuery(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTicketQueryDetails, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadTicketQuerySuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadTicketQuerySuccess([]))
          yield put(loadTicketQueryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadTicketQuerySuccess([]))
        yield put(
          loadTicketQueryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const newLabel = yield call(loadRecordsMetaData, "ticket_label", "post")

      const employeeLabel = yield call(
        loadRecordsMetaData,
        "employee_dropdown_list",
        "post"
      )
      const processStatus = yield call(
        loadRecordsMetaData,
        "process_status",
        "post"
      )
      let recordsMetaData = {
        labelOptions:
          (newLabel &&
            newLabel.data &&
            newLabel.data.length > 0 &&
            newLabel.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.labelName,
                    shortCode: c.shortCode,
                    value: c._id,
                  }
                )
              )) ||
          (newLabel &&
            newLabel.length > 0 &&
            newLabel.map((c) =>
              Object.assign(
                {},
                {
                  label: c.labelName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        employeeListOptions:
          (employeeLabel &&
            employeeLabel.data &&
            employeeLabel.data.length > 0 &&
            employeeLabel.data.map((e) =>
              Object.assign(
                {},
                {
                  label: `${e.empCode} - ${e.name}`,
                  value: e._id,
                  empCode: e.empCode,
                  name: e.name,
                }
              )
            )) ||
          [],
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p._id,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
      }
      console.log(recordsMetaData, "my details")
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
// add clearance

function* addTicketQueryDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(ADD_TICKET_QUERY),
    })

    const { explicitLoad } = load

    const { ticketQuery } = explicitLoad || {}
    yield put(addTicketQuery(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(addTicketQueryDetails, ticketQuery)
        console.log("api result is", result)

        if (result) {
          yield put(addTicketQuerySuccess(result.data))
          console.log(result.data)
        } else {
          yield put(addTicketQuerySuccess([]))
          yield put(addTicketQueryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(addTicketQuerySuccess([]))
        yield put(
          addTicketQueryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateTicketQuerySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(UPDATE_TICKET_QUERY),
    })

    const { explicitLoad } = load

    const { updateQuery } = explicitLoad || {}
    yield put(updateTicketQuery(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(updateTicketQueryDetails, updateQuery)
        console.log("api result is", result)

        if (result) {
          yield put(updateTicketQuerySuccess(result.data))
          console.log(result.data)
        } else {
          yield put(updateTicketQuerySuccess([]))
        }
      } catch (error) {
        yield put(
          updateTicketQueryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* deleteTicketQuerySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(DELETE_TICKET_QUERY),
    })

    const { explicitLoad } = load

    const { deleteTicket } = explicitLoad || {}
    yield put(deleteTicketQuery(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(deleteTicketQueryDetails, deleteTicket)
        console.log("api result is", result)

        if (result) {
          yield put(deleteTicketQuerySuccess(result.data))
          console.log(result.data)
        } else {
          yield put(deleteTicketQuerySuccess([]))
        }
      } catch (error) {
        yield put(
          deleteTicketQueryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadTicketQueryDetailsSaga(),
    addTicketQueryDetailsSaga(),
    updateTicketQuerySaga(),
    deleteTicketQuerySaga(),
  ])
}
